<template>
  <div class="form-recipient-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header title="Criar">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'form-recipients.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <form-recipient-form
        @submit="onSubmit"
        :errors="errors"
        :saving="isSaving"
      ></form-recipient-form>
    </app-card>
  </div>
</template>

<script>
import FormRecipientForm from '@/components/Forms/FormRecipientForm.vue';
import FormRecipientService from '@/services/form-recipient.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'form-recipient-form-page',
  mixins: [ToastMixin],
  components: { FormRecipientForm },
  data: () => {
    return {
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.erros = {};
      this.save(data);
    },
    save(data) {
      this.isSaving = true;
      FormRecipientService.save(data)
        .then(() => {
          this.toastify('E-mail cadastrado com sucesso!');
          this.$router.push({ name: 'form-recipients.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar e-mail',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
};
</script>

<style lang="sass" scoped></style>
